"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.66664 6.66676H6.67497M1.66663 4.33342L1.66663 8.06219C1.66663 8.46984 1.66663 8.67367 1.71268 8.86548C1.7535 9.03554 1.82084 9.19811 1.91223 9.34723C2.0153 9.51543 2.15942 9.65956 2.44767 9.94781L8.83821 16.3383C9.82825 17.3284 10.3233 17.8234 10.8941 18.0089C11.3962 18.172 11.9371 18.172 12.4392 18.0089C13.01 17.8234 13.505 17.3284 14.4951 16.3383L16.3382 14.4952C17.3283 13.5052 17.8233 13.0101 18.0088 12.4393C18.1719 11.9372 18.1719 11.3963 18.0088 10.8942C17.8233 10.3234 17.3283 9.82838 16.3382 8.83833L9.94769 2.4478C9.65943 2.15954 9.51531 2.01542 9.34711 1.91235C9.19799 1.82097 9.03542 1.75363 8.86536 1.7128C8.67354 1.66675 8.46972 1.66675 8.06207 1.66675L4.3333 1.66675C3.39988 1.66675 2.93316 1.66675 2.57664 1.8484C2.26304 2.00819 2.00807 2.26316 1.84828 2.57677C1.66663 2.93329 1.66663 3.4 1.66663 4.33342ZM7.0833 6.66676C7.0833 6.89687 6.89675 7.08342 6.66664 7.08342C6.43652 7.08342 6.24997 6.89687 6.24997 6.66676C6.24997 6.43664 6.43652 6.25009 6.66664 6.25009C6.89675 6.25009 7.0833 6.43664 7.0833 6.66676Z",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;